// GA4 ecommerce dataLayer helpers.
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce

const CURRENCY = 'EUR';

/**
 * @param {object} product product from the shop data
 * @param {object} extra additional GA4 item fields (quantity, index, item_list_name, ...)
 * @return {object} GA4 item
 */
export function productToItem(product, extra = {}) {
    return {
        item_id: String(product.id),
        item_name: product.name,
        item_brand: product.brand,
        item_category: product.category,
        item_category2: product.subcategory,
        price: product.price,
        quantity: 1,
        ...extra,
    };
}

/**
 * @param {array} items GA4 items
 * @return {number} sum of price * quantity
 */
export function itemsValue(items) {
    return items.reduce((value, item) => value + item.price * (item.quantity || 1), 0);
}

/**
 * Pushes a GA4 ecommerce event, clearing the previous ecommerce object first so
 * that fields from an earlier event are not merged into this one.
 *
 * @param {string} event GA4 event name
 * @param {object} ecommerce ecommerce payload without the currency
 */
export function pushEcommerce(event, ecommerce) {
    if (!window.dataLayer) window.dataLayer = [];

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event,
        ecommerce: {
            currency: CURRENCY,
            ...ecommerce,
        },
    });
}
